import { convertServerUploadFileErrorMessage } from "../helpers/server-error-util.js";
import session from "../session.js";

/**
 * Handle file uploads.
 *
 * This service is a more modern take on file uploads, and superseeds `ajaxUpload.js`.
 *
 * @param {string} [spec.uploadPath] - Server endpoint to perform the POST request.
 */
export default class UploadService {
	constructor({ uploadPath = "/Shared/Attachment/" } = {}) {
		this._uploadPath = uploadPath;
	}

	uploadFile(file) {
		return new Promise((resolve, reject) => {
			const data = new FormData();
			const xhr = new XMLHttpRequest();

			data.append(file.name, file, file.name);

			xhr.addEventListener("load", () => {
				const response = xhr.responseText
					? JSON.parse(xhr.responseText)
					: undefined;

				if (xhr.status < 400) {
					resolve(response);
				} else {
					const message = convertServerUploadFileErrorMessage({
						message: response?.message,
					});
					reject(new Error(message));
				}
			});

			xhr.addEventListener("error", reject);
			xhr.open("POST", this._uploadPath, true);

			xhr.setRequestHeader(
				"AntiForgeryToken",
				session.getAntiForgeryToken(),
			);

			xhr.send(data);
		});
	}

	setUploadPath(uploadPath) {
		this._uploadPath = uploadPath;
	}
}
